<div class="-business-type-skeleton">
  <div class="-welcome-section">
    <div class="-welcome-shell">
      <div class="text-container">
        <wp-skeleton height="16px" [width]="'32%'" [loading]="true" class="-text-platforms"></wp-skeleton>
        <wp-skeleton height="56px" [width]="'82%'" [loading]="true"></wp-skeleton>
        <wp-skeleton height="18px" [width]="'92%'" [loading]="true"></wp-skeleton>
        <wp-skeleton height="18px" [width]="'88%'" [loading]="true"></wp-skeleton>
        <wp-skeleton height="18px" [width]="'76%'" [loading]="true"></wp-skeleton>
        <wp-skeleton height="18px" [width]="'64%'" [loading]="true"></wp-skeleton>
        <wp-skeleton height="42px" [width]="'132px'" [loading]="true" class="-button"></wp-skeleton>
      </div>

      <div class="img-container">
        <wp-skeleton height="360px" [width]="'420px'" [loading]="true" class="-hero-placeholder"></wp-skeleton>
      </div>
    </div>
  </div>

  <div class="-business-section">
    @for (section of [1, 2, 3]; track section) {
    <div class="-business-type-new">
      <div class="-section-copy">
        <wp-skeleton height="38px" [width]="'72%'" [loading]="true" class="-section-title"></wp-skeleton>
        <wp-skeleton height="18px" [width]="'92%'" [loading]="true"></wp-skeleton>
        <wp-skeleton height="18px" [width]="'84%'" [loading]="true"></wp-skeleton>
        <wp-skeleton height="18px" [width]="'68%'" [loading]="true"></wp-skeleton>
        <wp-skeleton height="18px" [width]="'54%'" [loading]="true" class="-section-link"></wp-skeleton>
      </div>
      <div class="grid">
        @for (card of section === 1 ? [1, 2, 3, 4, 5] : [1, 2]; track card) {
        <div class="-category-column">
          <wp-skeleton height="20px" [width]="'78%'" [loading]="true" class="-card-title"></wp-skeleton>
          <wp-skeleton height="14px" [width]="'100%'" [loading]="true"></wp-skeleton>
          <wp-skeleton height="14px" [width]="'94%'" [loading]="true"></wp-skeleton>
          <wp-skeleton height="14px" [width]="'84%'" [loading]="true"></wp-skeleton>
          <wp-skeleton height="14px" [width]="'36px'" [loading]="true" class="-flag"></wp-skeleton>
        </div>
        }
      </div>
    </div>
    }
  </div>
</div>
